import React from 'react'
import { Flex, Heading } from '@chakra-ui/react'

export const Card = React.forwardRef(({ heading, children, ...props }, ref) => (
  <Flex p={5} direction='column' borderWidth='1px' {...props}>
    {heading && (
      <Heading as='p' size='sm' mb={3} textAlign='center'>
        {heading}
      </Heading>
    )}
    {children}
  </Flex>
))

export default Card
